import Grid from "@material-ui/core/Grid";
import { useAssetDetailsContext } from "../context/assetDetailsContext";
import "../styles.css";
import TableAssetDetails from "./assetDetailsTable/assetDetailsTabs";
import StatisticsTabs from "./statistics/statisticsTabs";
import WorkOrdersTabs from "./workOrders/workOrdersTabs";

type Props = {
	searchStatistics: Function;
	isStatisticsLoading: boolean;
};

export default function SplitScreen({
	searchStatistics,
	isStatisticsLoading,
}: Props) {
	const {
		state: { statisticsTable, assetsTable, workOrdersTable },
	} = useAssetDetailsContext();

	const getTopSectionHeight = () => {
		if (assetsTable && statisticsTable && workOrdersTable) {
			return "60%";
		}
		if ((assetsTable || statisticsTable) && workOrdersTable) {
			return "65%";
		}
		return "100%";
	};

	const getWorkOrdersHeight = () => {
		if (assetsTable && statisticsTable && workOrdersTable) {
			return "calc(40% - 8px)";
		}
		if ((assetsTable || statisticsTable) && workOrdersTable) {
			return "calc(35% - 8px)";
		}
		return "100%";
	};

	const getContainerPaddingBottom = () => {
		if (
			(workOrdersTable && !assetsTable && !statisticsTable) ||
			(assetsTable && statisticsTable && workOrdersTable)
		) {
			return 110;
		}
		if ((assetsTable || statisticsTable) && !workOrdersTable) {
			return 20;
		}
		return 0;
	};

	return (
		<>
			<Grid
				container
				style={{ height: "100%", paddingBottom: getContainerPaddingBottom() }}
			>
				<Grid
					item
					md={statisticsTable ? 9 : 12}
					xs={12}
					style={
						assetsTable && statisticsTable && workOrdersTable
							? {
									display: "inherit",
									height: getTopSectionHeight(),
									paddingRight: "4px",
								}
							: assetsTable && statisticsTable && !workOrdersTable
								? { display: "inherit", height: "100%", paddingRight: "4px" }
								: assetsTable && !statisticsTable && !workOrdersTable
									? {
											display: "inherit",
											height: "100%",
										}
									: assetsTable && !statisticsTable && workOrdersTable
										? {
												display: "inherit",
												height: getTopSectionHeight(),
											}
										: { display: "none" }
					}
				>
					<TableAssetDetails searchStatistics={searchStatistics} />
				</Grid>
				<Grid
					item
					md={assetsTable ? 3 : 12}
					xs={12}
					style={
						statisticsTable && assetsTable && workOrdersTable
							? {
									display: "inherit",
									height: getTopSectionHeight(),
									paddingLeft: "4px",
								}
							: statisticsTable && !assetsTable && !workOrdersTable
								? {
										display: "inherit",
										height: "100%",
									}
								: statisticsTable && !assetsTable && workOrdersTable
									? {
											display: "inherit",
											height: getTopSectionHeight(),
										}
									: statisticsTable && assetsTable && !workOrdersTable
										? {
												display: "inherit",
												height: "100%",
												paddingLeft: "4px",
											}
										: { display: "none" }
					}
				>
					<StatisticsTabs isStatisticsLoading={isStatisticsLoading} />
				</Grid>
				<Grid
					item
					md={12}
					xs={12}
					style={
						!workOrdersTable
							? { display: "none" }
							: {
									display: "inherit",
									height: getWorkOrdersHeight(),
									paddingTop:
										workOrdersTable && (assetsTable || statisticsTable)
											? "8px"
											: "0px",
								}
					}
				>
					<WorkOrdersTabs />
				</Grid>
			</Grid>
		</>
	);
}
